import { SkeletonBody } from '@xing-com/skeleton';

import { Styled } from './topic-article-skeleton.styles';

export const TopicArticleSkeleton: React.FC = () => (
  <Styled.SkeletonWrapper>
    <Styled.SkeletonHeadline />
    <Styled.SkeletonBodyCopy />
    <SkeletonBody />
  </Styled.SkeletonWrapper>
);
